import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { VALID_DIVISIONS } from '../constants/divisions';

const DIVISIONS = VALID_DIVISIONS.map((id) => ({
  id,
  name: `Division ${id.charAt(1)}`,
}));

export default function DivisionSelectPage() {
  const navigate = useNavigate();

  const handleDivisionSelect = (divisionId: string) => {
    localStorage.setItem('lastDivision', divisionId);
    navigate(`/leaderboard/${divisionId}`);
  };

  return (
    <div className="app-container">
      <Header />

      <main className="main-content">
        <div className="page-header">
          <h2>Select Your Division</h2>
          <p>Choose a division to view the leaderboard</p>
        </div>

        <div className="division-select-container">
          {DIVISIONS.map((division) => (
            <button
              key={division.id}
              className="division-select-button"
              onClick={() => handleDivisionSelect(division.id)}
            >
              {division.name}
            </button>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
